//API ref
export const OPEN_MENU_NAVBAR = 'OPEN_MENU_NAVBAR';
export const CHANGE_SELECTED_VALUE = 'CHANGE_SELECTED_VALUE';
export const CHANGE_HEIGHT_VALUE = 'CHANGE_HEIGHT_VALUE';
